import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var clip = function clip(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
  return Math.min(Math.max(value, min), max);
};
/**
 * The reducer only stores proportions, and is independant of location.
 * The orientation etc. is handled by the component itself.
 * This means that pixel values are temporarily only needed for calculation, and come in through actions.
 */


var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'toggleFirstElement':
      return _objectSpread(_objectSpread({}, state), {}, {
        collapsedFirstElement: !state.collapsedFirstElement
      });

    case 'toggleLastElement':
      return _objectSpread(_objectSpread({}, state), {}, {
        collapsedLastElement: !state.collapsedLastElement
      });
    // Initialises the draggingState based on current offsets and sizes.

    case 'startDragging':
      {
        var collapsedSize = state.collapsedSize,
            draggingState = state.draggingState,
            sizePercentages = state.sizePercentages;
        var index = action.index,
            parentOffset = action.parentOffset,
            parentSize = action.parentSize,
            startPosition = action.startPosition;
        if (draggingState) throw new Error('Already dragging');
        var draggingDiffMin = -sizePercentages[index] / 100 * parentSize;
        var draggingDiffMax = sizePercentages[index + 1] ? sizePercentages[index + 1] / 100 * parentSize : startPosition - (parentOffset + parentSize);
        draggingDiffMin += collapsedSize;
        draggingDiffMax -= collapsedSize;
        return _objectSpread(_objectSpread({}, state), {}, {
          draggingState: {
            draggingDiff: 0,
            draggingDiffMax: draggingDiffMax,
            draggingDiffMin: draggingDiffMin,
            draggingIndex: index,
            startDraggingAt: startPosition
          }
        });
      }
    // Only updates draggingDiff value

    case 'dragUpdate':
      {
        var _draggingState = state.draggingState;
        if (!_draggingState) throw new Error('Cannot fire dragUpdate without starting to drag');
        var _draggingDiffMax = _draggingState.draggingDiffMax,
            _draggingDiffMin = _draggingState.draggingDiffMin,
            startDraggingAt = _draggingState.startDraggingAt;
        var currentDraggingDiff = action.clientLoc - startDraggingAt;
        return _objectSpread(_objectSpread({}, state), {}, {
          draggingState: _objectSpread(_objectSpread({}, _draggingState), {}, {
            draggingDiff: clip(currentDraggingDiff, _draggingDiffMin, _draggingDiffMax)
          })
        });
      }
    // Calculates new sizeProportions etc. based on last recorded draggingState

    case 'stopDragging':
      {
        var _draggingState2 = state.draggingState;
        if (!_draggingState2) throw new Error('Cannot fire stopDragging without starting to drag');
        var diffPercentage = _draggingState2.draggingDiff / action.parentSize * 100;
        var minProportion = state.collapsedSize / action.parentSize * 100;
        var draggingIndex = _draggingState2.draggingIndex;
        var _sizePercentages = state.sizePercentages;
        var nbChildren = _sizePercentages.length;
        var collapsedFirstElement = state.collapsedFirstElement,
            collapsedLastElement = state.collapsedLastElement;
        var nextElementBaseSize;
        var draggingElementBaseSize;

        if (draggingIndex === 0 && collapsedFirstElement) {
          draggingElementBaseSize = minProportion;
          nextElementBaseSize = _sizePercentages[draggingIndex + 1];
        } else if (draggingIndex === nbChildren - 2 && collapsedLastElement) {
          draggingElementBaseSize = _sizePercentages[draggingIndex];
          nextElementBaseSize = minProportion;
        } else {
          draggingElementBaseSize = _sizePercentages[draggingIndex];
          nextElementBaseSize = _sizePercentages[draggingIndex + 1];
        }

        var newSizes = _toConsumableArray(_sizePercentages);

        var newDraggingElementSize = draggingElementBaseSize + _sizePercentages[draggingIndex + 1] - nextElementBaseSize + diffPercentage;
        var newNextElementSize = nextElementBaseSize + _sizePercentages[draggingIndex] - draggingElementBaseSize - diffPercentage;
        newSizes[draggingIndex] = newDraggingElementSize;
        newSizes[draggingIndex + 1] = newNextElementSize;
        return _objectSpread(_objectSpread({}, state), {}, {
          collapsedFirstElement: draggingIndex === 0 && newDraggingElementSize <= minProportion,
          collapsedLastElement: draggingIndex === nbChildren - 2 && newNextElementSize <= minProportion,
          draggingState: undefined,
          sizePercentages: newSizes
        });
      }

    default:
      throw new Error("Invalid Action ".concat(action));
  }
};

export default reducer;